import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectCompSequence } from './orderSelectors.ts';
import { selectImprovementsCost, selectImprovementsCosts } from './selectImprovementsCost.ts';
import { selectSiteValue, selectSiteValues } from './selectSiteValue.ts';

export const selectPropertyValueById = createSelector(
  [selectImprovementsCost, selectSiteValue],
  (improvementsCost, siteValue) => {
    if (isUndefined(improvementsCost) || isUndefined(siteValue)) {
      return undefined;
    }

    return improvementsCost.add(siteValue);
  },
);

export const selectPropertyValueDisplayById = createSelector(
  [selectPropertyValueById],
  (propertyValue) => {
    if (isUndefined(propertyValue)) {
      return undefined;
    }

    return propertyValue.toString(true);
  },
);

export const selectPropertyValues = createSelector(
  [selectCompSequence, selectImprovementsCosts, selectSiteValues],
  (compSequence, improvementsCosts, siteValues) =>
    compSequence.reduce((acc: Record<string, AloftPrice>, compId) => {
      const improvementsCost = improvementsCosts?.[compId];
      const siteValue = siteValues?.[compId];

      if (isUndefined(improvementsCost) || isUndefined(siteValue)) {
        return acc;
      }

      acc[compId] = improvementsCost.add(siteValue);
      return acc;
    }, {}),
);
